import { render, staticRenderFns } from "./FournisseursList.vue?vue&type=template&id=6f1a2482&scoped=true&"
import script from "./FournisseursList.vue?vue&type=script&lang=js&"
export * from "./FournisseursList.vue?vue&type=script&lang=js&"
import style0 from "./FournisseursList.vue?vue&type=style&index=0&id=6f1a2482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a2482",
  null
  
)

export default component.exports